<template>
  <!-- Teleport con backdrop: overlay que bloquea el fondo y cierra al click en el overlay -->
  <teleport to="body">
    <div class="ticket-motivos-backdrop" @click.self="$emit('close')">
      <div class="ticket-motivos-content" role="dialog" aria-modal="true">
        <div class="modal-header">
          <h3 class="modal-title">{{ $t('motivos_cierre_apertura') }}</h3>
          <button
            type="button"
            class="btn-close"
            @click="$emit('close')"
            aria-label="Close"
          >
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="table-container full-width-table">
            <table class="table">
              <thead>
                <tr>
                  <th style="text-align: center;">{{ $t('fecha') }}</th>
                  <th style="text-align: center;">{{ $t('motivo') }}</th>
                  <th style="text-align: center;">{{ $t('tipo') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="motivo in motivos" :key="motivo.id">
                  <td>
                    {{ motivo.fecha ? motivo.fecha.substring(0, 16).replace('T', ' ') : '-' }}
                  </td>
                  <td style="text-align: left;">{{ motivo.descripcion }}</td>
                  <td>
                    <span :style="{ color: motivo.esCierre ? '#28a745' : '#99172A', fontWeight: 'bold' }">
                      {{ motivo.esCierre ? $t('cierre') : $t('reapertura') }}
                    </span>
                  </td>
                </tr>
                <tr v-if="motivos.length === 0">
                  <td colspan="3" style="text-align: center; color: #888;">{{ $t('no_motivos_registrados') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import api from '../api';
import Swal from 'sweetalert2';

export default {
  name: 'TicketMotivosModal',
  props: {
    ticketId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      motivos: [],
      // opcional: estado de carga
      isLoading: false,
    };
  },
  async mounted() {
    if (import.meta.env.DEV) console.debug('TicketMotivosModal abierto para ticket:', this.ticketId);
    await this.loadMotivos();
  },
  methods: {
    async loadMotivos() {
      this.isLoading = true;
      try {
        const res = await api.get(`/ticket-cierre/${this.ticketId}`);
  if (import.meta.env.DEV) console.debug('Respuesta motivos:', res.data);
        this.motivos = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        if (import.meta.env.DEV) console.error('Error al cargar motivos:', e);
        this.motivos = [];
        Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudieron cargar los motivos.', showConfirmButton: false, timer: 2500 });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Backdrop que bloquea el fondo */
.ticket-motivos-backdrop {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.45);
  z-index: 2147483650;
  padding: 12px;
  box-sizing: border-box;
}

/* El contenido del modal sí recibe eventos */
.ticket-motivos-content {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.2);
  max-width: 720px;
  width: 100%;
  margin: 0;
  pointer-events: auto;
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #99172A;
  color: #fff;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  margin-top: 0;
  left:0;
}
.modal-title {
  margin: 0;
  font-size: 1.6rem;
  font-weight: bold;
  flex: 1;
  text-align: center;
  padding: 18px 48px;
}
.btn-close {
  background: transparent;
  border: none;
  cursor: pointer;
  color: #fff;
  font-size: 1.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  transition: opacity 0.2s;
  position: absolute;
  top: 50%;
  right: 18px;
  transform: translateY(-50%);
  z-index: 10;
}
.btn-close:hover {
  opacity: 1;
}
.modal-body {
  padding: 12px 28px 28px 28px;
  margin-top: 6px;
  overflow: visible;
}
.table-container.full-width-table {
  width: 100%;
  max-height: 380px;
  overflow-y: auto;
  margin-bottom: 20px;
}
.table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0;
  background: #fff;
}
.table th,
.table td {
  border: 1px solid #ced4da;
  padding: 10px;
  text-align: center;
}
.table th {
  background-color: #f8f9fa;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 3;
}

/* Forzar ocultado de cualquier backdrop interno que pudiera quedar */
.debug-modal-backdrop,
.modal-backdrop {
  display: none !important;
}
</style>